import { ActivatedRouteSnapshot, ResolveFn } from "@angular/router";
import { TiltakApiService } from "./tiltak-api-service";
import { inject } from "@angular/core";
import { Tiltak } from "../../models/oppsummering.model";

export const tiltakResolver: ResolveFn<Tiltak> = (route: ActivatedRouteSnapshot) => {
  const id = Number(route.paramMap.get("id"));
  const besvarelseId = route.queryParamMap.get("besvarelseId") ?? undefined;
  return inject(TiltakApiService).getTiltak(id, besvarelseId);
}
